import { styled } from '../../Utilities';
import { SpinnerBase } from './Spinner.base';
import { getStyles } from './Spinner.styles';
export var Spinner = styled(SpinnerBase, getStyles, undefined, { scope: 'Spinner' });
//# sourceMappingURL=Spinner.js.map